<template>
    <div class="hs-container">
        <!-- 添加 -->
        <div class="handle-left">
            <div class="search-left">
                <el-button class="mr8" type="primary" @click="showDrawerPass(_self, 'editCategory', 'showDrawer', ['add', {}, query.role])">添加</el-button>
                <el-input v-model="query.title" class="handle-input mr10 el-input el-input--small el-input--suffix" placeholder="请输入分类名称" clearable></el-input>
                <el-button type="primary" class="btn-search ml8" @click="changeHandler">搜索</el-button>
                <el-button type="primary" class="btn-search ml8" @click="reset">重置</el-button>
            </div>
        </div>
        <!-- 导航 S-->
        <div class="nav-check-status">
            <div class="nav-left">
                <el-radio-group v-model="query.parent_id" @change="changeHandler">
                    <el-radio-button v-for="(item,index) in parents" :label="item.id" :key="index">{{item.title}}</el-radio-button>
                </el-radio-group>
            </div>
            <div class="nav-right">
                <el-button type="warning" @click="showDrawerPass(_self, 'editCategory', 'showDrawer', ['save', currentParent, query.role])">编辑</el-button>
            </div>
        </div>
        <!-- 导航 E-->
        <!-- 表格S -->
        <div class="hs-masterlist">
            <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" highlight-current-row v-loading="loading">
                <el-table-column prop="id" label="ID" width="100"></el-table-column>
                <el-table-column prop="title" label="分类名称"></el-table-column>
                <el-table-column prop="sort" label="排序" width="180"></el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
                <el-table-column label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="showDrawerPass(_self, 'editAttr', 'showDrawer', [scope.row.id])">规格</el-button>
                        <el-button type="warning" @click="showDrawerPass(_self, 'editCategory', 'showDrawer', ['save', scope.row])">编辑</el-button>
                        <el-button type="danger" @click="delRow(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 表格E -->
        <!-- 底部S -->
        <div class="footer-box">
            <div class="pagination" v-if="isPagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>
        <!-- 底部E -->
        <!-- 组件引用S -->
        <edit-category ref="editCategory" :parents="parents" @getParents="getParents" @getTableData="getTableData" :parent="_self"></edit-category>
        <!-- 设置规格 -->
        <edit-attr ref="editAttr"></edit-attr>
        <edit-min-price ref="editMinPrice"></edit-min-price>
    </div>
</template>

<script>
import {
    showDrawerPass,
    checkDataAuth
} from '@/utils/common.js';
import editCategory from './edit.vue';
import editAttr from './attr/attr.vue';
import editMinPrice from './price/min.vue'

// 初始参数
const ruleForm = {
    role: '',
    parent_id: 1,
    title: '',
};
export default {
    components: {
        editCategory,
        editAttr,
        editMinPrice
    },

    data() {
        let tableHeight = window.innerHeight - 300;
        let windowheight = window.innerHeight;
        return {
            role: '',
            //列表 tablelist 高度设置 翻页
            loading: false,
            tableHeight: tableHeight,
            windowheight: windowheight,
            tableData: [],
            //反映翻页
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            isPagination: {},
            auth: {},
            query: Object.assign({}, ruleForm),
            //导航数据
            parents: [],
            // 当前主类别
            currentParent: [],
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    created() {
        // 验证搜索权限
        let _this = this;
        checkDataAuth().then((res) => {
            _this.auth = res;
        })
        this.query.role = this.$route.query.role;
        this.getParents();
        this.getTableData();
    },
    watch: {
        $route: function (to, from) {
            this.query.role = to.query.role;
            this.getParents();
            this.getTableData();
        }
    },
    methods: {
        changeHandler() {
            this.pagination.page = 1;
            this.getTableData();
        },
        //导航数据
        getParents() {
            let _this = this;
            let url = '/api/supplier.category/parent';
            this.$post(url, this.query).then(res => {
                if (res.code == '200') {
                    _this.parents = res.data.list;
                }
            })
        },
        //切换导航数据对应的表格
        changeHandler(value) {
            this.currentParent = this.parents.find(ele => ele.id == value);

            this.query.parent_id = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        // 获取列表数据
        getTableData() {
            let that = this;
            that.loading = true;
            let url = "/api/supplier.category/index"
            let query = this.query;
            query['pagination'] = this.pagination;
            this.$post(url, query).then(function (response) {
                if (response.code == 200) {
                    that.tableData = response.data.list;
                    that.pagination = response.data.pagination;
                    that.loading = false;
                }
            });
        },
        delRow(id) {
            let _this = this,
                url = "/api/supplier.category/delete",
                params = {
                    id: id
                };
            this.$confirm('确定删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$post(url, params).then(function (res) {
                    if (res.code == 200) {
                        _this.getTableData();
                        this.$message({
                            type: 'success',
                            message: res.msg
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        // 清空筛选项
        reset() {
            this.query = Object.assign({}, ruleForm);
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
    }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');

.nav-check-status {
    display: flex;

    .nav-left {
        flex: 1;
    }

    .nav-right {
        flex: 0 10%;
        text-align: right;
    }
}
</style>
